import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner, Collapse } from "react-bootstrap";
import { archiveComplianceList, removeArchiveComplianceList, permanentDeleteComplianceList } from "../../../services/SIService";
import TableLoaderEffect from "../../constant/TableLoader";
import DynamicSelectInput from "../../constant/SelectInput";

const maxWidthStyle300 = {
  maxWidth: "30rem",
  minWidth: "10rem",
  whiteSpace: "normal",
  display: "block"
}


const ArchiveCompliancePage = () => {
  const [complianceList, setComplianceList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [openADSearch, setOpenADSearch] = useState(false);
  const [advanceFilterInput, setAdvanceFilterInput] = useState({
    description: "",
    department_id: "",
    unit_id: "",
  });
  const [isClearAll, setIsClearAll] = useState(false);
  const [selectedCompliance, setSelectedCompliance] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isShowArchiveForm, setIsShowArchiveForm] = useState(false);
  const [isShowDeleteForm, setIsShowDeleteForm] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSubmitLoadingDel, setIsSubmitLoadingDel] = useState(false);


  const navigate = useNavigate();
  useEffect(() => {
    setIsLoading(true);
    archiveComplianceList(searchQuery,
      advanceFilterInput.department_id,
      advanceFilterInput.unit_id,
    ).then((resp) => {
      setComplianceList(resp.data.results);
      setIsLoading(false);
      setIsSearchLoading(false)
    })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
          setIsLoading(false);
          setIsSearchLoading(false)
        } else {
          console.log(error);
        }
      });
    }, [searchQuery,
      advanceFilterInput.department_id,
      advanceFilterInput.unit_id]);
      
      
      const handleSearchChange = (e) => {
        const { value } = e.target;
        if (value) {
          setIsSearchLoading(true)
        }
        setSearchQuery(value);
      };
      

      const toggleADSearch = () => {
        setOpenADSearch(!openADSearch);
      };
      
      const toggleArchiveForm = () => {
        setIsShowArchiveForm(!isShowArchiveForm);
      } 
      
      const toggleDeleteForm = () => {
        setIsShowDeleteForm(!isShowDeleteForm);
      };
      
      
      const toggleCheckbox = (id) => {
        setSelectedCompliance((prevSelected) => {
          if (prevSelected.includes(id)) {
            return prevSelected.filter((item) => item !== id);
          } else {
            return [...prevSelected, id];
          }
        });
      };
      
      const handleSelectAll = () => {
        if (selectedCompliance.length === complianceList.length) {
          setSelectedCompliance([]);
        } else {
          setSelectedCompliance(complianceList.map((item) => item.id));
        }
      };
      
      const handleSelectChange = (name, value, _) => {
        const newFilter = { ...advanceFilterInput, [name]: value }
        setAdvanceFilterInput(newFilter);
        setIsClearAll(false)
      };
      
      const handleArchiveSubmit = () => {
        if(isSubmitLoadingDel || isSubmitLoading){
          return 
        }
        setIsSubmitLoading(true);
        removeArchiveComplianceList({ compliance_id_list: selectedCompliance }).then((resp) => {
          toast.success(resp.data.message);
          setIsSubmitLoading(false);
          setSelectedCompliance([])
          toggleArchiveForm()
          navigate('/si?type=compliance')
        })
        .catch((error) => {
          if (error.response) {
          toast.error(error.response.data.message);
          console.log(error.response.data.message);
          setIsSubmitLoading(false);
          setSelectedCompliance([])
          toggleArchiveForm()
        } else {
          console.log(error);
        }
      });
  }


  const handleDeleteSubmit = () => {
    if(isSubmitLoadingDel || isSubmitLoading){
      return 
    }
    setIsSubmitLoadingDel(true);
    permanentDeleteComplianceList({ compliance_id_list: selectedCompliance }).then((resp) => {
      setIsSubmitLoadingDel(false);
      setSelectedCompliance([])
      toggleDeleteForm()
      toast.success(resp.data.message);
      navigate('/si?type=compliance')
    })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
          toast.error(error.response.data.message);
          setIsSubmitLoadingDel(false);
          setSelectedCompliance([])
          toggleDeleteForm()
        } else {
          console.log(error);
        }
      });
  }

  const handleClear = () => {
    setIsClearAll(true)
    setAdvanceFilterInput({
      department_id: "",
      unit_id: "",
    });
  };



  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="px-3 py-3">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-start align-items-sm-center flex-column flex-sm-row">
                    <div className="d-flex  align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-circle"
                        onClick={() => navigate("/dashboard")}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <h5 className="mb-0 ms-2 fw-bold">Archived Compliance</h5>
                    </div>
                    <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
                      <div className="me-3 mb-3 mb-md-0">
                        <div className="input-group tp-input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={searchQuery}
                            aria-describedby="basic-search"
                            onChange={handleSearchChange}
                          />
                          <div className="input-group-text" id="basic-search">
                            {isSearchLoading && (
                              <Spinner variant="primary" size="sm" />
                            )}
                            {!isSearchLoading &&
                              searchQuery.length > 0 ? (
                              <i
                                className="fa-solid fa-xmark c-pointer text-primary"
                                onClick={() => {
                                  setSearchQuery("");
                                }}
                              ></i>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-outline-primary me-2 mb-3 mb-md-0"
                        onClick={toggleADSearch}
                      >
                        Advance Search
                      </button>
                    </div>
                  </div>
                  <div className="mt-4">
                    <Collapse in={openADSearch} className="border rounded px-3 pt-3">
                      <div id="collapse-example">
                        <div className="row">
                          <div className="col-lg-2 col-md-6 col-sm-6 ">
                            <DynamicSelectInput
                              setParentInputValue={handleSelectChange}
                              endpoint_name="search/department"
                              labelHint={false}
                              isClearable={true}
                              label={"Department"}
                              name={"department_id"}
                              id={"department_id"}
                              isSetEmpty={isClearAll}
                            />
                          </div>
                          <div className="col-lg-2 col-md-6 col-sm-6 ">
                            <DynamicSelectInput
                              setParentInputValue={handleSelectChange}
                              endpoint_name="search/unit"
                              labelHint={false}
                              isClearable={true}
                              label={"Unit"}
                              name={"unit_id"}
                              id={"unit_id"}
                              isSetEmpty={isClearAll}
                            />
                          </div>
                          <div className="col-lg-1 col-md-3 col-sm-6 d-flex align-items-center">
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={handleClear}>
                              Clear All
                            </button>
                          </div>
                        </div>
                      </div>
                    </Collapse>
                  </div>

                  {selectedCompliance.length > 0 &&
                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <div className="bg-success-light rounded p-2">
                          <h4 className="text-center">Total <strong>{selectedCompliance.length}</strong> Compliance selected.</h4>
                          {isShowArchiveForm ? <div className="px-3">
                            <p className="text-center fw-bold text-success">Are you sure, you want to unarchive the selected Compliance.</p>
                            <center className="mt-3 mb-2">
                              <button className="btn btn-success btn-sm me-2"
                                disabled={isSubmitLoading}
                                onClick={handleArchiveSubmit}>
                                {isSubmitLoading ? (
                                  <span>
                                    <Spinner size="sm" className="me-2" />Confirm...
                                  </span>
                                ) : "Confirm"}
                              </button>
                              <button className="btn btn-outline-danger btn-sm"
                                disabled={isSubmitLoading}
                                onClick={toggleArchiveForm}>Cancel</button>
                            </center>
                          </div> : <>
                            <p className="text-center fw-bold text-success">To unarchive selected Compliance, please click below to continue.</p>
                            <center>
                              <button className="btn btn-success btn-sm" onClick={toggleArchiveForm}>Continue</button>
                            </center>
                          </>}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="bg-danger-light rounded p-2">
                          <h4 className="text-center">Total <strong>{selectedCompliance.length}</strong> Compliance selected.</h4>
                          {isShowDeleteForm ? <div className="px-3">
                            <p className="text-center text-danger fw-bold">Are you sure, you want to permanently delete the selected Compliance.</p>
                            <center className="mt-3 mb-2">
                              <button className="btn btn-primary btn-sm me-2"
                                disabled={isSubmitLoadingDel}
                                onClick={handleDeleteSubmit}>
                                {isSubmitLoadingDel ? (
                                  <span>
                                    <Spinner size="sm" className="me-2" />Confirm...
                                  </span>
                                ) : "Confirm"}
                              </button>
                              <button className="btn btn-outline-danger btn-sm"
                                disabled={isSubmitLoadingDel}
                                onClick={toggleDeleteForm}>Cancel</button>
                            </center>
                          </div> : <>
                            <p className="text-center fw-bold text-danger">To permanently delete selected Compliance, please click below to continue.</p>
                            <center>
                              <button className="btn btn-danger btn-sm" onClick={toggleDeleteForm}>Continue</button>
                            </center>
                          </>}
                        </div>
                      </div>
                    </div>
                  }

                </div>

                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <div className="form-check custom-checkbox checkbox-primary">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedCompliance.length === complianceList.length && complianceList.length !== 0}
                                onChange={handleSelectAll}
                              />
                            </div>
                          </th>
                          <th>Reference Number</th>
                          <th>Department</th>
                          <th>Unit</th>
                          <th>Archive Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <TableLoaderEffect colLength={6} />
                        ) : (
                          complianceList.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="form-check custom-checkbox checkbox-primary">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectedCompliance.includes(item.id)}
                                    onChange={() => toggleCheckbox(item.id)}
                                  />
                                </div>
                              </td>
                              <td>{item.reference_number}</td>
                              <td>{item.department?.name || ""}</td>
                              <td>{item.unit?.name || ""}</td>
                              <td> <span style={maxWidthStyle300}>{item.archive_reason}</span></td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default ArchiveCompliancePage;
